console.debug(`VUE_APP_ISCACHE: ${process.env.VUE_APP_ISCACHE}`)
// const isCache = process.env.VUE_APP_ISCACHE === 'true' ? true : false
const BASEURL_DOMAIN = process.env.VUE_APP_APIURL_WORLDCUP
const BASEURL_API = process.env.VUE_APP_APIURL_API

import liveMonitoringList from './mock/marathon/liveMonitoringList'

// marathon 接口 start ---------

function computedBaseUrl(baseApi) {
  // 不同开发环境，不同接口根目录，导致域名不同
  let baseUrl = ''
  if (
    process.env.NODE_ENV === 'development' &&
    process.env.VUE_APP_API === 'development'
  ) {
    // 本地开发
    return baseApi
  }
  if (baseApi.indexOf('/api') === 0) {
    baseUrl = BASEURL_API
  } else {
    baseUrl = BASEURL_DOMAIN
  }
  return baseUrl + baseApi
}

// 马拉松获取赛季 接口
export const https_marathon_seasonList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(`${baseUrl}/cmp/findseasoninfos/${params.cid}`)
  )
}

// 赛季下马拉松 接口
export const https_marathon_stageteammenu = (baseUrl, axios, params) => {
  return axios.get(computedBaseUrl(`${baseUrl}/args/findProjectCode`))
}

// 运动员性别 接口
export const https_marathon_genderCode = (baseUrl, axios) => {
  return axios.get(computedBaseUrl(`${baseUrl}/args/findGenderCode`))
}

// 报名数据 接口
export const https_marathon_palyerSignup = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/apply/findathleteinfos/${params.sid}?pcode=${params.pcode}&gcode=${params.gcode}&aname=${params.aname}&pnum=${params.pnum}&psize=${params.psize}`
    )
  )
}

// 报名数据 接口
export const https_marathon_gamesTimeResults = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/score/findathletescores/${params.sid}?pcode=${params.pcode}&gcode=${params.gcode}&aname=${params.aname}&pnum=${params.pnum}&psize=${params.psize}`
    )
  )
}

// 直播监看list || 摄像机位list 分页 接口
export const https_marathon_liveMonitoringList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/vcr/video/camera/position/list/${params.matchId}/${params.code}?page=${params.page}&pageSize=${params.pageSize}`
    )
  )
  // return axios.mock(liveMonitoringList)
}

// 直播监看list || 摄像机位list  不带分页 接口
export const https_marathon_cameraList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/vcr/video/camera/position/listnopage/${params.matchId}/${params.code}`
    )
  )
  // return axios.mock(liveMonitoringList)
}

// 获取视频模版 接口
export const https_marathon_videoTemplateList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/hl/template/list/${params.matchId}?code=${params.code}`
    )
  )
}

// 视频模版参数 接口
export const https_marathon_videoTemplateParamsDetail = (
  baseUrl,
  axios,
  params
) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/hl/template/params/${params.matchId}/${params.tplId}`
    )
  )
}

// 更新视频模版参数 接口
export const https_marathon_updateVideoTemplateParamsDetail = (
  axios,
  params
) => {
  console.debug(params)
  return axios.post(
    computedBaseUrl(
      `${baseUrl}/hl/template/params/${params.matchId}/${params.tplId}`
    ),
    params.postData,
    {
      headers: {
        'content-type': 'application/json',
      },
    }
  )
}

// 添加摄像机位 接口
export const https_marathon_addCameraItem = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/vcr/camera/position/add/${params.matchId}`),
    params.postData
  )
}

// 添加视频模版 接口
export const https_marathon_addVideoTemplateItem = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/hl/template/add/${params.matchId}`),
    params.postData
  )
}

// 修改摄像机位 接口
export const https_marathon_updateCameraItem = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(
      `${baseUrl}/vcr/camera/position/update/${params.matchId}/${params.streamId}`
    ),
    params.postData
  )
}

// 修改视频模版 接口
export const https_marathon_updateVideoTemplateItem = (
  baseUrl,
  axios,
  params
) => {
  return axios.post(
    computedBaseUrl(
      `${baseUrl}/hl/template/update/${params.matchId}/${params.tplId}`
    ),
    params.postData
  )
}

// 删除摄像机位 接口
export const https_marathon_removeCameraItem = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(
      `${baseUrl}/vcr/camera/position/del/${params.matchId}/${params.streamId}`
    ),
    {}
  )
}

// 运动员切片列表 接口
export const https_marathon_playerSectionList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/vcr/video/clip/list/${params.matchId}/${params.tplId}/${params.code}?athleteName=${params.athleteName}&page=${params.page}&pageSize=${params.pageSize}`
    )
  )
}

// 运动员锦集列表 接口
export const https_marathon_playerCollectionList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/hl/highlight/list/${params.matchId}/${params.tplId}/${params.code}?athleteName=${params.athleteName}&page=${params.page}&pageSize=${params.pageSize}`
    )
  )
}

// 单个运动员合成锦集 接口
export const https_marathon_playerSingleSynthesis = (
  baseUrl,
  axios,
  params
) => {
  return axios.post(
    computedBaseUrl(
      `${baseUrl}/hl/highlight/gen/${params.matchId}/${params.tplId}/${params.athleteNum}`
    )
  )
}

// 单个运动员发布锦集 接口
export const https_marathon_playerSinglePublish = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(
      `${baseUrl}/hl/highlight/pub/${params.matchId}/${params.tplId}/${params.athleteNum}`
    )
  )
}

// 单个运动员是否禁用 接口
export const https_marathon_playerSingleDisable = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(
      `${baseUrl}/hl/highlight/disable/${params.matchId}/${params.tplId}/${params.athleteNum}`
    ),
    params.postData
  )
}

// 生产通过马拉松类型和视频模版筛选后的所有运动员的合成锦集 =》 顶部筛选框最右侧的 【合成锦集】 接口
export const https_marathon_matchTemplateCollection = (
  baseUrl,
  axios,
  params
) => {
  return axios.post(
    computedBaseUrl(
      `${baseUrl}/hl/highlight/genbatch/${params.matchId}/${params.tplId}`
    ),
    params.postData
  )
}

// 生产通过马拉松类型和视频模版筛选后的所有运动员的发布锦集 =》 顶部筛选框最右侧的 【发布锦集】 接口
export const https_marathon_matchTemplatePublish = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(
      `${baseUrl}/hl/highlight/pubbatch/${params.matchId}/${params.tplId}`
    ),
    params.postData
  )
}

// 查询通过马拉松类型和视频模版筛选后的合成锦集的进度 =》 顶部筛选框最右侧的 进度条的百分比 接口
export const https_marathon_matchTemplateCollectionRate = (
  baseUrl,
  axios,
  params
) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/hl/highlight/rate/${params.matchId}/${params.tplId}/${params.code}`
    )
  )
}

// 单个运动员下 某个切片的 【编辑时间】 接口
export const https_marathon_playerClipItemEidtOffset = (
  baseUrl,
  axios,
  params
) => {
  return axios.post(
    computedBaseUrl(
      `${baseUrl}/vcr/clip/athlete/offset/${params.matchId}/${params.tplId}/${params.athleteNum}`
    ),
    params.postData
  )
}

// 单个运动员下 某个切片的 【生产切片】 接口
export const https_marathon_playerClipItemProduction = (
  baseUrl,
  axios,
  params
) => {
  return axios.post(
    computedBaseUrl(
      `${baseUrl}/vcr/clip/athlete/gen/${params.matchId}/${params.tplId}/${params.athleteNum}`
    ),
    params.postData
  )
}

// 单个运动员下的 【生产切片】 接口
export const https_marathon_playerItemClip = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(
      `${baseUrl}/vcr/clip/athlete/gencamera/${params.matchId}/${params.tplId}/${params.athleteNum}`
    ),
    {}
  )
}

// 生产通过马拉松类型和视频模版筛选后的所有运动员的切片 =》 顶部筛选框最右侧的 【生产切片】 接口
export const https_marathon_matchTemplateClip = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(
      `${baseUrl}/vcr/clip/athlete/genmatch/${params.matchId}/${params.tplId}`
    ),
    params.postData
  )
}

// 查询通过马拉松类型和视频模版筛选后的生产切片的进度 =》 顶部筛选框最右侧的 进度条的百分比 接口
export const https_marathon_matchTemplateClipRate = (
  baseUrl,
  axios,
  params
) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/vcr/clip/athlete/rate/${params.matchId}/${params.tplId}/${params.code}`
    )
  )
}

// 计时毯列表 接口
export const https_marathon_timingpointsList = (baseUrl, axios) => {
  return axios.get(computedBaseUrl(`${baseUrl}/vcr/video/clip/timingpoints`))
}

// 删除视频模版 接口
export const https_marathon_removeVideoTemplateItem = (
  baseUrl,
  axios,
  params
) => {
  return axios.post(
    computedBaseUrl(
      `${baseUrl}/hl/template/del/${params.matchId}/${params.tplId}`
    ),
    {}
  )
}

// 查询单个模板 接口
export const https_marathon_videoTemplateItemDetail = (
  baseUrl,
  axios,
  params
) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/hl/template/single/${params.matchId}/${params.tplId}`
    )
  )
}

// // marathon 接口 end ---------

// 测试网络超时
export const https_server_timeOut = (axios, params) => {
  return axios.get(computedBaseUrl(`/testdemo/testdata`))
}
